import Markdown from "react-markdown"
import styled from "styled-components"

export function MMarkdown({ children }: { children: string }) {
  return (
    <MarkdownWrapper>
      <Markdown>{children}</Markdown>
    </MarkdownWrapper>
  )
}

const MarkdownWrapper = styled.div`
  & p:first-child {
    margin-top: 0;
  }

  & p:last-child {
    margin-bottom: 0;
  }
`
